import { useEffect, useState } from "react";
import { Button, Input, Grid, Card, CardContent, InputLabel, Typography, FormControlLabel, Checkbox } from "@mui/material";
import { FacebookIcon, FacebookShareButton, WhatsappIcon, WhatsappShareButton } from "react-share";
import converter from 'number-to-words';
import "jspdf-autotable";
import { toast } from "react-toastify";

const THNKPage = (props) => {

    const [amount, setAmount] = useState({})
    const [state, setState] = useState(false)
    const initialFormData = Object.freeze({
        pan: '',
        address: '',
        name: '',
    });
    const [formData, updateFormData] = useState(initialFormData);
    const [btn, setBtn] = useState('0')
    const [cert, setCert] = useState(false)

    const checkValid = (data) => {

        let valid = true;

        Object.values(data).forEach(val => {
            val.length < 1 && (valid = false);
        })
        return valid;


    }

    const handleChange = (e) => {
        updateFormData({
            ...formData,
            // Trimming any whitespace
            [e.target.name]: e.target.value.trim(),
        });

    }


    const handleChange2 = (e) => {
        setState(!state)
    }

    useEffect(() => {


        fetch(process.env.REACT_APP_API_URL + '/api/donate/fetch', { method: 'POST', headers: { 'Content-Type': 'application/json' }, 'body': JSON.stringify({ 'order_id': props.location.state.detail.razorpayPaymentId }), })
            .then(res => res.json())
            .then(data => {

                setAmount(data)
                fetch(`${process.env.REACT_APP_API_URL}/api/act/fund_update/${props.location.state.form.event.EventID}`,
                    {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        'body': JSON.stringify({ 'donation': data['amount'] / 100 })
                    })
                    .then(res => res.json())
                    .then(data => {

                    }).catch(err => {

                    })

                fetch(`${process.env.REACT_APP_API_URL}/api/donation/create`,
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            "Program": props.location.state.form.program ? props.location.state.form.program.ProgramId : '',
                            "ProgramName": props.location.state.form.program ? props.location.state.form.program.ProgramName : '',
                            "Event": props.location.state.form.event ? props.location.state.form.event.EventID : '',
                            "EventName": props.location.state.form.event ? props.location.state.form.event.Title : '',
                            "User": props.location.state.user_id,
                            "DonatorName": props.location.state.name ? props.location.state.name : data.email,
                            "DonatorEmail": props.location.state.email ? props.location.state.email : data.email,
                            "DonationAmount": props.location.state.form.amount,
                            "Note": props.location.state.form.note,
                            "DonatorPhone": props.location.state.contact ? props.location.state.contact : data.contact,
                            "DonationMethod": data.method,
                            "RazorpayOrderId": data.order_id,
                            "RazorpayPaymentId": data.id,
                            "RazorpayCreatedAt": data.created_at,
                            "Platform": process.env.REACT_APP_TITLE,
                            "Category": props.location.state.form.category
                        })
                    })
                    .then(res => res.json())
                    .then(data => {

                    })

                fetch(process.env.REACT_APP_API_URL + '/api/certificate', {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        "order_id": data['order_id'],
                        "domain": window.location.origin,
                        "hostname": window.location.hostname
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        if (data['status'] === 'true') {
                            setCert(true)
                        } else {
                            setCert(false)
                        }
                    })
            })


        // eslint-disable-next-line 
    }, [])

    const certificate = () => {
        if (checkValid(formData)) {
            setBtn('1')
            fetch(process.env.REACT_APP_API_URL + '/api/certificate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({

                    "name": formData.name,
                    "pan": formData.pan,
                    "address": formData.address,
                    "amount": (amount['amount'] / 100) + '.00' + amount['currency'],
                    "words": converter.toWords(amount['amount'] / 100) + ' only',
                    "mode": amount['method'],
                    "email_id": formData['email'],
                    "order_id": amount['order_id'],
                    "domain": window.location.origin,
                    "hostname": window.location.hostname

                })

            })
                .then(res => res.blob())
                .then((blob) => {
                    setBtn('2')
                    const url = window.URL.createObjectURL(
                        new Blob([blob]),
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        `80GCertificate${formData.name}.pdf`,
                    );

                    // Append to html link element page
                    document.body.appendChild(link);

                    // Start download
                    link.click();

                    // Clean up and remove the link
                    link.parentNode.removeChild(link);


                })
        }
        else {
            toast.error('Please fill all the fields')
        }
    }


    return (


        <div style={{ backgroundColor: '#FF957D' }}>

            <Grid container spacing={1} style={{ marginTop: 135, fontFamily: 'Raleway', backgroundColor: 'white' }}>
                <Grid item xs={1} md={2}></Grid>
                <Grid item md={8} style={{ textAlign: 'center' }}>
                    <Card>
                        <CardContent>
                            <Grid container spacing={1}>
                                <Grid item xs={1} md={2}></Grid>
                                <Grid item xs={12}>
                                    <i style={{ fontSize: 58, backgroundColor: '#00D387', color: 'white', borderRadius: 30 }} className='material-icons'>check_circle_outline</i>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography style={{ textAlign: 'center', color: '#00D387', fontFamily: 'Raleway', fontSize: 38 }}>   <strong> DONATION SUCCESSFUL </strong></Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography style={{ textAlign: 'center', fontFamily: 'Raleway', marginTop: 20 }}>Thank you for you contribution of <strong> ₹ {amount['amount'] / 100}  </strong>, you’re a lifesaver!</Typography>
                                    <br></br>

                                </Grid>

                                {!cert ?
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name='checked'
                                                    defaultChecked={state}
                                                    onChange={handleChange2}
                                                    color="primary"
                                                    style={{ fontFamily: 'Raleway' }}
                                                />
                                            }
                                            label="Do you want to generate an 80G Certificate?"
                                        />
                                    </Grid> : ''}
                            </Grid>

                            {state ?
                                <Grid container>

                                    <Grid item md={12} />
                                    <Grid item xs={12} style={{ fontSize: 28, marginBottom: 10, marginTop: 10 }}>

                                        Please fill out all the fields below

                                    </Grid>
                                    <Grid item md={1} />

                                    <Grid item xs={12} md={6}>
                                        <InputLabel style={{ textAlign: 'left', marginTop: 10 }}>Full Name</InputLabel>
                                        <Input
                                            variant="outlined"
                                            required
                                            size='small'
                                            fullWidth

                                            id="name"
                                            name="name"
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item md={12} />
                                    <Grid item md={1} />
                                    <Grid item xs={12} md={6}>
                                        <InputLabel style={{ textAlign: 'left', marginTop: 10 }}>PAN Number</InputLabel>
                                        <Input
                                            variant="outlined"
                                            required
                                            size='small'
                                            fullWidth

                                            id="pan"
                                            name="pan"
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item md={12} />
                                    <Grid item md={1} />
                                    <Grid item xs={12} md={6}>
                                        <InputLabel style={{ textAlign: 'left', marginTop: 10 }}>Email Address</InputLabel>
                                        <Input
                                            variant="outlined"
                                            required
                                            size='small'
                                            fullWidth
                                            id="email"
                                            name="email"
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid item md={12} />
                                    <Grid item md={1} />
                                    <Grid item xs={10} >
                                        <InputLabel style={{ textAlign: 'left', marginTop: 10 }}>Address</InputLabel>
                                        <Input
                                            variant="outlined"
                                            required
                                            size='small'

                                            fullWidth
                                            id="address"
                                            name="address"
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <br></br>
                                    <Grid item xs={12} style={{ marginTop: 20 }}>
                                        {btn === '0' ? <Button onClick={() => { certificate() }} style={{ backgroundColor: '#ff8800', color: 'white' }}>Generate 80G Certificate</Button> : ''}
                                        {btn === '1' ? <Button disabled onClick={() => { certificate() }} style={{ backgroundColor: 'grey', color: 'white' }}>Generate 80G Certificate</Button> : ''}
                                    </Grid>
                                </Grid> : ''}
                        </CardContent>
                        <CardContent style={{ backgroundColor: '#F5F5F5' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={3}></Grid>
                                <Grid item xs={12} md={6} style={{ textAlign: 'center' }}>
                                    You can make an bigger difference by sharing this with you friends and family on social media as every share helps us improve our reach tremendously.

                                </Grid>
                                <br></br>
                                <br></br><br></br>
                                <Grid item xs={4} md={4}></Grid>


                                <Grid item xs={2}>
                                    <FacebookShareButton
                                        url='https://www.giftoftime.in'
                                        quote={`I have just donated ₹${amount['amount'] / 100} to the Gift of Time foundation!. Join us at Gift of Time and clock in your goodwill hours `}
                                        hashtag='#got'>
                                        <FacebookIcon style={{ height: 30 }}></FacebookIcon>
                                    </FacebookShareButton>

                                </Grid>

                                <Grid item xs={2}>

                                    <WhatsappShareButton
                                        title={`I have just donated ₹${amount['amount'] / 100} to the Gift of Time foundation!. Join us at Gift of Time and clock in your goodwill hours `}
                                        url='https://www.giftoftime.in'
                                    >
                                        <WhatsappIcon style={{ height: 30 }}></WhatsappIcon>
                                    </WhatsappShareButton>
                                </Grid>
                            </Grid>

                        </CardContent>
                    </Card>
                    <br></br>

                </Grid>
            </Grid>

        </div>
    )


}

export default THNKPage 